export const getEffStacks = ({players, startStack, actionsHistory}) => {

    // get start eff stack
    const stacks = {}
    const lastStreetBets = {}
    if (players) {
        for (const actPlayer in players) {
            // get structure for *active* players
            stacks[actPlayer] = startStack

            lastStreetBets[actPlayer] = players && players[actPlayer].startBet

            // iterate over actions made
            for (let i = 0; i < actionsHistory.length; i++) {
                // get action
                const action = actionsHistory[i]

                // check if it is action
                if (action.type !== 'action') {
                    // substrate last street bets from stack
                    stacks[actPlayer] = stacks[actPlayer] - lastStreetBets[actPlayer]

                    // make last street bets 0
                    lastStreetBets[actPlayer] = 0
                } else {
                    // get player
                    const player = action.role

                    // get value
                    const actionParts = action.action.split(' ')

                    // if has bet
                    if (actionParts.length > 1) {
                        const bet = parseFloat(actionParts[actionParts.length - 1])
                        lastStreetBets[player] = bet
                    }
                }
            }

            // substrate if only on street
            if (
                (actionsHistory &&
                    actionsHistory.length > 0 &&
                    actionsHistory[actionsHistory.length - 1].type === 'action') ||
                (actionsHistory && actionsHistory.length === 0)
            ) {
                // substrate last street bets from stack
                stacks[actPlayer] = stacks[actPlayer] - lastStreetBets[actPlayer]
            }
        }
    }

    return stacks
}